var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgContour(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 1.25C4.65482 1.25 4.375 1.52982 4.375 1.875C4.375 2.22018 4.65482 2.5 5 2.5H9.60417C9.94934 2.5 10.2292 2.22018 10.2292 1.875C10.2292 1.52982 9.94934 1.25 9.60417 1.25H5Z",
    fill: "#667085"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.125 6.25C8.125 5.90482 7.84518 5.625 7.5 5.625C7.15482 5.625 6.875 5.90482 6.875 6.25V8.74998C6.875 8.91574 6.94085 9.07471 7.05805 9.19192L7.99555 10.1294C8.23963 10.3735 8.63536 10.3735 8.87944 10.1294C9.12352 9.88537 9.12352 9.48964 8.87945 9.24556L8.125 8.4911V6.25Z",
    fill: "#667085"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.5 3.125C4.56599 3.125 2.1875 5.50349 2.1875 8.4375C2.1875 11.3715 4.56599 13.75 7.5 13.75C10.434 13.75 12.8125 11.3715 12.8125 8.4375C12.8125 7.59144 12.6147 6.79158 12.2629 6.08162C12.2816 6.06675 12.2997 6.05066 12.317 6.03333L12.942 5.40833C13.1861 5.16426 13.1861 4.76853 12.942 4.52445C12.698 4.28037 12.3022 4.28037 12.0582 4.52445L11.5653 5.01734C10.5908 3.86021 9.13124 3.125 7.5 3.125ZM3.4375 8.4375C3.4375 6.19384 5.25634 4.375 7.5 4.375C9.74366 4.375 11.5625 6.19384 11.5625 8.4375C11.5625 10.6812 9.74366 12.5 7.5 12.5C5.25634 12.5 3.4375 10.6812 3.4375 8.4375Z",
    fill: "#667085"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContour);
export default __webpack_public_path__ + "static/media/Contour.01921336be643f4952adf29006bf0141.svg";
export { ForwardRef as ReactComponent };